import { Box, Icon, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { getCreditBalance } from 'services/api/modules/recruitment/credit'

const AvailableCredit = ({}) => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate('/app/recruitment/credit/top-up')
  }
  const {
    isLoading: creditBalanceIsLoading,
    error: creditBalanceError,
    data: creditBalanceData,
  } = useQuery(
    ['getCreditBalance'],
    async () => {
      const { data } = await getCreditBalance()
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      columnGap={2}
      padding={2}
      marginBottom={4}
      sx={{
        bgcolor: 'white.main',
        height: 120,
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" columnGap={2} alignitems="center">
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={60}
            height={60}
            bgcolor="alternate.light"
            color="white.main"
            borderRadius="50%"
          >
            <Icon sx={{ color: 'alternate.main' }}>wallet</Icon>
          </Box>

          <Box>
            <Typography
              variant="body1"
              color="light-gray-text.main"
              marginBottom={0.5}
              align="left"
            >
              Available credits
            </Typography>

            <Typography component="span" variant="h3" color="dark-text.main">
              RM {creditBalanceData?.current_credit_balance ?? 0}.00
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box display="flex" columnGap={4}>
        <AdxButton variant={'contained'} size="standard" sx={{ width: 150 }} onClick={handleClick}>
          <Icon>add</Icon>
          Topup
        </AdxButton>
      </Box>
    </Box>
  )
}
export default AvailableCredit
